"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHistory = exports.history_template = void 0;
var lodash_1 = __importDefault(require("lodash"));
exports.history_template = {
    "a": "//quote.eastmoney.com/[#MARKET#][#CODE#].html",
    "b": "//guba.eastmoney.com/topic,[#CODE#].html",
    "c": "//fund.eastmoney.com/[#CODE#].html",
    "d": "//quote.eastmoney.com/hk/[#CODE#].html",
    "e": "//quote.eastmoney.com/gzqh/[#CODE#].html",
    "f": "//quote.eastmoney.com/zs[#CODE#].html",
    "g": "//quote.eastmoney.com/qihuo/[#CODE#].html",
    "h": "//quote.eastmoney.com/hk/[#CODE#].html",
    "i": "//quote.eastmoney.com/hk/zs[#CODE#].html",
    "j": "//quote.eastmoney.com/us/[#CODE#].html",
    "k": "//quote.eastmoney.com/forex/[#CODE#].html",
    "l": "//quote.eastmoney.com/[#MARKET#][#CODE#].html",
    "m": "//quote.eastmoney.com/gb/zs[#CODE#].html",
    "n": "//quote.eastmoney.com/globalfuture/[#CODE#].html",
    "o": "//quote.eastmoney.com/qiquan/[#CODE#]_[#MARKET#].html",
    "p": "//quote.eastmoney.com/3ban/[#MARKET#][#CODE#].html",
    "kcb": "//quote.eastmoney.com/kcb/[#CODE#].html",
    "ty": "//quote.eastmoney.com/unify/r/[#MARKET#].[#CODE#]"
};
/** 最大条数 */
var max_size = 10;
/**
 * 获取浏览记录
 * @param size 最多显示多少条
 */
function getHistory(size) {
    var c_value = ''; //cookie.get_old('HAList')
    if (window.localStorage) {
        if (localStorage.getItem('HAList')) {
            c_value = localStorage.getItem('HAList');
        }
    }
    if (c_value) {
        var hlist = c_value.split(',')
            .map(function (v) { return v.split('-'); })
            .filter(function (v) { return v.length >= 4; })
            .map(function (v) {
            if (v.length == 6) { //期权特殊情况
                v[2] = v.slice(2, 5).join('-');
                v[3] = v[5];
                v = v.slice(0, 4);
            }
            else if (v.length > 4) {
                v[3] = v.slice(3).join('-');
                v = v.slice(0, 4);
            }
            return v;
        })
            .filter(function (v) {
            return Object.keys(exports.history_template).includes(v[0]);
        })
            .filter(function (v) {
            return v[3] != 'undefined';
        })
            .map(function (v) {
            var market = v[1];
            if (market.toLowerCase() == 'sz') {
                market = '0';
            }
            else if (market.toLowerCase() == 'sh') {
                market = '1';
            }
            var quotecode = "".concat(market, ".").concat(v[2]);
            return {
                name: v[3],
                link: exports.history_template[v[0]].replace("[#MARKET#]", v[1]).replace("[#CODE#]", v[2]),
                quotecode: quotecode
            };
        });
        hlist = lodash_1.default.uniqBy(hlist, 'quotecode');
        hlist = hlist.slice(0, size);
        // console.info(hlist)
        return (hlist);
    }
    return [];
}
exports.getHistory = getHistory;
